exports.__esModule = true;
var __importDefault = function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var docs_config_1 = __importDefault(require("@tencent/docs-config"));
var appConfigInstance = docs_config_1.default.getInstance();
var npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
exports.default = (function () {
    var p = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.CDN_ORIGIN) || "https://docs.gtimg.com/docs-design-resources";
    p = p + "/document-management/tencent-docs/png-200px/"
    return {
        "application-json": p+"application-json.png",
        "application-ofd": p+"application-ofd.png",
        "application-pdf": p+"application-pdf.png",
        "application-vnd.ms-excel": p+"application-vnd.ms-excel.png",
        "application-vnd.ms-powerpoint": p+"application-vnd.ms-powerpoint.png",
        "application-vnd.ms-word": p+"application-vnd.ms-word.png",
        "application-vnd.tdocs-addon-image.236b7f64e91e40b584f2aae0517ee1ed": p+"application-vnd.tdocs-addon-image.236b7f64e91e40b584f2aae0517ee1ed.png",
        "application-vnd.tdocs-addon-image.84e7b8f3a6b542b380cd984b94b1752c": p+"application-vnd.tdocs-addon-image.84e7b8f3a6b542b380cd984b94b1752c.png",
        "application-vnd.tdocs-addon-image.9e2c26161b684629a9bf29e52efa6c60": p+"application-vnd.tdocs-addon-image.9e2c26161b684629a9bf29e52efa6c60.png",
        "application-vnd.tdocs-addon-image.e3e96c1968114db986a9229003965853": p+"application-vnd.tdocs-addon-image.e3e96c1968114db986a9229003965853.png",
        "application-vnd.tdocs-addon-image.f87386fee10348178ee65f8eedc4b2f3": p+"application-vnd.tdocs-addon-image.f87386fee10348178ee65f8eedc4b2f3.png",
        "application-vnd.tdocs-apps.board": p+"application-vnd.tdocs-apps.board.png",
        "application-vnd.tdocs-apps.collaboration-space-root": p+"application-vnd.tdocs-apps.collaboration-space-root.png",
        "application-vnd.tdocs-apps.collaboration-space": p+"application-vnd.tdocs-apps.collaboration-space.png",
        "application-vnd.tdocs-apps.cooperation-space": p+"application-vnd.tdocs-apps.cooperation-space.png",
        "application-vnd.tdocs-apps.default": p+"application-vnd.tdocs-apps.default.png",
        "application-vnd.tdocs-apps.doc": p+"application-vnd.tdocs-apps.doc.png",
        "application-vnd.tdocs-apps.flowchart": p+"application-vnd.tdocs-apps.flowchart.png",
        "application-vnd.tdocs-apps.folder": p+"application-vnd.tdocs-apps.folder.png",
        "application-vnd.tdocs-apps.form": p+"application-vnd.tdocs-apps.form.png",
        "application-vnd.tdocs-apps.markdown": p+"application-vnd.tdocs-apps.markdown.png",
        "application-vnd.tdocs-apps.mind": p+"application-vnd.tdocs-apps.mind.png",
        "application-vnd.tdocs-apps.ofd": p+"application-vnd.tdocs-apps.ofd.png",
        "application-vnd.tdocs-apps.rec": p+"application-vnd.tdocs-apps.rec.png",
        "application-vnd.tdocs-apps.safe-folder": p+"application-vnd.tdocs-apps.safe-folder.png",
        "application-vnd.tdocs-apps.share-folder": p+"application-vnd.tdocs-apps.share-folder.png",
        "application-vnd.tdocs-apps.shared-folder": p+"application-vnd.tdocs-apps.shared-folder.png",
        "application-vnd.tdocs-apps.sheet": p+"application-vnd.tdocs-apps.sheet.png",
        "application-vnd.tdocs-apps.slide": p+"application-vnd.tdocs-apps.slide.png",
        "application-vnd.tdocs-apps.smartcanvas": p+"application-vnd.tdocs-apps.smartcanvas.png",
        "application-vnd.tdocs-apps.smartsheet": p+"application-vnd.tdocs-apps.smartsheet.png",
        "application-zip": p+"application-zip.png",
        "audio": p+"audio.png",
        "code": p+"code.png",
        "drive-excel": p+"drive-excel.png",
        "drive-powerpoint": p+"drive-powerpoint.png",
        "drive-word": p+"drive-word.png",
        "image": p+"image.png",
        "text": p+"text.png",
        "video": p+"video.png",
        "visio": p+"visio.png",
        "xmind": p+"xmind.png",
    };
})();